module.exports = __webpack_public_path__ + "img/数据同步物资清洗.6fd33b57.svg";